import axios from 'axios';
import _ from 'lodash';
import {
  apiErrorHandler,
  helperConvertApiRoute,
  helperGetApiHeaders,
  helperGetApiRoute,
  helperGetApiRouteById,
  helperGetApiHeadersv2,
} from 'helpers/ApiHelper';
import { concatToUrl } from 'helpers/ContentHelper';
import { getPrimetimeDateRange } from 'helpers/DateTimeHelper';
import { fetchFooter } from 'components/Footer/FooterActions';
import { getPrimeTimeNetworkFilter } from './LiveHelpers';

export const FETCH_LIVE = 'FETCH_LIVE';
export const FETCH_LIVE_PANEL = 'FETCH_LIVE_PANEL';
export const FETCH_LIVE_NEXT_PAGE = 'FETCH_LIVE_NEXT_PAGE';
export const FETCH_LIVESTREAM = 'FETCH_LIVESTREAM';
export const FETCH_PRIME_TIME = 'FETCH_PRIME_TIME';
export const SET_SUGGESTED_CHANNEL = 'SET_SUGGESTED_CHANNEL';
export const CLEAR_LIVE = 'CLEAR_LIVE';
export const SAVE_LIVE_VIDEO = 'SAVE_LIVE_VIDEO';
export const RESTORE_LIVE_GRID_STATE = 'RESTORE_LIVE_GRID_STATE';

const appendToUrl = ({ url, network, dateRange, coordinates }) => {
  const lat = _.get(coordinates, 'latitude', null);
  const lng = _.get(coordinates, 'longitude', null);

  let newUrl = url;
  if (network) newUrl = concatToUrl(newUrl, `network=${network}`);
  if (dateRange) newUrl = concatToUrl(newUrl, `dateRange=${dateRange}`);
  if (lat && lng) newUrl = concatToUrl(newUrl, `geoLatitude=${lat}&geoLongitude=${lng}`);

  return newUrl;
};

function fetchNextPage({ accessToken, nextUrl: url, deviceId }) {
  const data = axios
    .get(url, helperGetApiHeaders({ accessToken, deviceId }))
    .catch(e => apiErrorHandler({ error: e }));

  return {
    type: FETCH_LIVE_NEXT_PAGE,
    payload: data,
  };
}

async function fetchLive(response) {
  return {
    type: FETCH_LIVE,
    payload: response,
  };
}

export function fetchLiveAction({ accessToken, dateRange, coordinates, network, deviceId }) {
  return async (dispatch, getState) => {
    const { profile } = getState().app;
    const pageType = 'foxnation-live';
    let route = helperGetApiRoute(pageType);
    route = appendToUrl({ url: route, network, dateRange, coordinates });
    const headers = await helperGetApiHeadersv2({
      pathKey: pageType,
      accessToken,
      deviceId,
      checkToken: true,
      requiresAuth: true,
      profile,
    });
    const request = await axios.get(route, headers).catch(e => apiErrorHandler({ error: e }));
    return dispatch(fetchLive(request))
      .then(response => {
        const member = _.get(response, 'payload.data.panels.member', []);
        member.forEach(item => {
          const nextView = item?.items?.view?.next;
          if (nextView) {
            dispatch(fetchNextPage({ accessToken, nextUrl: nextView, deviceId }));
          }
        });
      })
      .then(() => dispatch(fetchFooter()));
  };
}

async function fetchPanel({
  accessToken,
  panelUrl,
  dateRange,
  coordinates,
  network,
  deviceId,
  profile,
}) {
  const pageType = 'live';
  let url = helperConvertApiRoute(panelUrl);
  url = appendToUrl({ url, network, dateRange, coordinates });
  const headers = await helperGetApiHeadersv2({
    pathKey: pageType,
    accessToken,
    deviceId,
    checkToken: true,
    requiresAuth: true,
    profile,
  });
  const request = axios.get(url, headers).catch(e => apiErrorHandler({ error: e }));

  return {
    type: FETCH_LIVE_PANEL,
    payload: request,
  };
}

export const fetchLivePanel = ({
  accessToken,
  panelUrl,
  dateRange,
  coordinates,
  network,
  deviceId,
}) => (dispatch, getState) => {
  const { profile } = getState().app;

  return dispatch(
    fetchPanel({ accessToken, panelUrl, dateRange, coordinates, network, deviceId, profile }),
  );
};

export function fetchLivestream(accessToken, livestreamId, deviceId) {
  const pageType = 'live';
  const url = helperGetApiRouteById('livestream', livestreamId, '{epgListingId}', true);
  const request = axios
    .get(url, helperGetApiHeaders({ pathKey: pageType, accessToken, deviceId }))
    .catch(e => apiErrorHandler({ error: e }));

  return {
    type: FETCH_LIVESTREAM,
    payload: request,
  };
}

export function fetchPrimeTime(accessToken, coordinates, deviceId) {
  const pageType = 'foxPrimetime';
  const dateRange = getPrimetimeDateRange();
  let url = helperGetApiRoute(pageType);
  const network = getPrimeTimeNetworkFilter();

  url = appendToUrl({ url, network, dateRange, coordinates });

  const request = axios
    .get(url, helperGetApiHeaders({ pathKey: pageType, accessToken, deviceId }))
    .catch(e => apiErrorHandler({ error: e }));

  return {
    type: FETCH_PRIME_TIME,
    payload: request,
  };
}

export function saveLiveVideo(video) {
  return {
    type: SAVE_LIVE_VIDEO,
    payload: video,
  };
}

export function setSuggestedChannel({ network, videoId, programId }) {
  return {
    type: SET_SUGGESTED_CHANNEL,
    payload: {
      data: {
        network,
        videoId,
        programId,
      },
    },
  };
}

export function clearLive() {
  return {
    type: CLEAR_LIVE,
  };
}

export function restoreLiveGridState(prevOpenRow, prevRowIdx) {
  return {
    type: RESTORE_LIVE_GRID_STATE,
    payload: {
      prevOpenRow,
      prevRowIdx,
    },
  };
}
